import { createApp } from 'vue'
import App from './App.vue'
import './css/styles.css'
import './css/normalize.css'
import router from './router/router'
const app = createApp(App)
import { createI18n } from 'vue-i18n' 
import locales from './dictionary/locales'
import  Store  from './store/index'
const i18n = createI18n({
    locale: navigator.language.startsWith('es') ? 'es' : 'en',
    fallbackLocale: 'en',
    messages: locales
  })
  
app.use(i18n).use(router).use(Store).mount('#app') 
